var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSitemapBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    d: "M13.03.51c-3.044 0-5.512 2.552-5.512 5.702 0 1.203.36 2.318.975 3.238l4.537 6.611 4.537-6.611c.615-.92.975-2.035.975-3.238 0-3.15-2.468-5.703-5.512-5.703m0 2.074c1.934 0 3.508 1.628 3.508 3.629 0 .74-.215 1.451-.606 2.037l-2.902 4.23-2.888-4.208a3.697 3.697 0 01-.62-2.06c0-2 1.574-3.628 3.508-3.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    d: "M15.536 6.212c0-1.432-1.122-2.592-2.506-2.592-1.384 0-2.506 1.16-2.506 2.592 0 1.431 1.122 2.592 2.506 2.592 1.384 0 2.506-1.16 2.506-2.592"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    d: "M23.554 25.421H2.506c-1.104 0-2.004-.93-2.004-2.073V8.832c0-1.143.9-2.073 2.004-2.073h3.508v2.073H2.506v14.516h21.048V8.832h-3.508V6.76h3.508c1.104 0 2.004.93 2.004 2.073v14.516c0 1.144-.9 2.073-2.004 2.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    d: "M2.543 17.645h2.004v-3.11H2.543zM21.239 22.789L5.704 17.605l.615-1.974 15.535 5.184zM12.232 22.792l-4.51-1.506.615-1.973 4.51 1.505zM21.211 19.154l-4.983-1.663.614-1.973 4.985 1.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    d: "M16.476 20.037l-1.908-.636 1.617-5.184 1.907.636zM8.49 22.639l-1.908-.637 1.511-4.845 1.908.637z"
  }))));
}
export default SvgSitemapBlack;